import axios from "./axiosInstance";

const shippingAPI = {
  list: (params) => axios.get("shipping/list", {params}),
  
  getRates: (payload) => axios.post("shipping/rates", payload),

  createShipment: (payload) => axios.post("shipping/create-shipment", payload),

  trackShipment: (shipmentLogId) => axios.get(`shipping/track/${shipmentLogId}`),
};

export default shippingAPI;
